module.exports = __webpack_public_path__ + "static/img/47.2cb4f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/47.png
// module id = 1g5x
// module chunks = 0